import { render, staticRenderFns } from "./creatPro.vue?vue&type=template&id=239ab935&scoped=true"
import script from "./creatPro.vue?vue&type=script&lang=js"
export * from "./creatPro.vue?vue&type=script&lang=js"
import style0 from "./creatPro.vue?vue&type=style&index=0&id=239ab935&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ab935",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('239ab935')) {
      api.createRecord('239ab935', component.options)
    } else {
      api.reload('239ab935', component.options)
    }
    module.hot.accept("./creatPro.vue?vue&type=template&id=239ab935&scoped=true", function () {
      api.rerender('239ab935', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/broadcast/product/creatPro.vue"
export default component.exports